// routes.js

import Brand from "./pages/Brand";
import ContentByTypeList from "./pages/ContentByType";
import ContentType from "./pages/ContentType";
import OrganizationList from "./pages/Organzations";
import ProductsList from "./pages/Products";
import Categories from './pages/Categories';
import Signin from "./pages/Signin";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Departments from "./pages/Departments";
import SectionsByDepartment from "./pages/Sections";
import Suppliers from "./pages/Suppliers";
import RoleMenu from "./pages/RoleMenu";
import ModuleScreens from "./pages/ModuleScreens";
import AlertsScreen from "./pages/Alerts";

const routes = [
    { path: "/content-by-type", element: <ContentByTypeList /> },
    { path: "/content-type", element: <ContentType /> },
    { path: "/products", element: <ProductsList /> },
    { path: "/brands", element: <Brand /> },
    { path: "/organizations", element: <OrganizationList /> },
    { path: "/categories", element: <Categories /> },
    { path: "/", element: <Signin /> },
    { path: "/dashboard", element: <Dashboard /> },
    { path: "/users", element: <Users /> },
    { path: "/departments", element: <Departments /> },
    { path: "/sections", element: <SectionsByDepartment /> },
    { path: "/suppliers", element: <Suppliers /> },
    { path: "/role-menu", element: <RoleMenu /> },
    { path: "/module-screen", element: <ModuleScreens /> },
    { path: "/alerts", element: <AlertsScreen /> },
];

export default routes;

